// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `wm-poi-box {
  cursor: pointer;
  margin: 10px;
}
wm-poi-box wm-img {
  height: 30px;
}
wm-poi-box ion-card {
  overflow: hidden;
  width: 90%;
  max-height: 250px;
  border-radius: 15px;
  padding: 10px;
  margin: auto;
  box-shadow: 0 2px 20px 0 rgba(0, 0, 0, 0.1);
}
wm-poi-box ion-card .wm-box-name {
  font-family: var(--wm-font-family-content, inherit);
}
wm-poi-box ion-card wm-img {
  display: block;
  background-color: var(--wm-color-skeleton);
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
wm-poi-box ion-card ion-label {
  color: var(--wm-color-darkgrey);
  height: var(--wm-font-sm);
  font-size: var(--wm-font-sm);
}
wm-poi-box ion-card ion-label span {
  font-weight: var(--wm-font-weight-bold);
}
wm-poi-box ion-card .wm-box-taxonomies {
  position: absolute;
  top: 10px;
  padding: 1%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}
wm-poi-box ion-card .wm-box-taxonomies .wm-box-taxonomy {
  left: 0px;
  top: 0px;
  border-radius: 25px;
  padding: 6px 10px 6px 10px;
  background-color: white;
  border: 1px solid #888888;
  margin: 3px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-content: stretch;
  align-items: center;
}
wm-poi-box ion-card .wm-box-taxonomies .wm-box-taxonomy i {
  color: unset;
}
wm-poi-box ion-card .wm-box-taxonomies .wm-box-taxonomy > * {
  flex: 0 1 auto;
  align-self: auto;
  display: inline-flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-content: center;
  align-items: center;
}
wm-poi-box ion-card .wm-box-header-no-photo {
  height: fit-content;
}
wm-poi-box ion-card .wm-box-header-no-photo .wm-box-taxonomies {
  position: relative;
  top: 0;
  padding: 1%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}
wm-poi-box ion-card ion-card-header {
  padding: 0 15px;
  text-align: left;
}
wm-poi-box ion-card ion-card-header ion-card-subtitle {
  text-align: left;
  color: var(--wm-color-primary);
  text-transform: uppercase;
  margin: 0;
  padding: 15px 0 0;
  font-size: var(--wm-font-xsm);
  font-weight: var(--wm-font-weight-light);
}
wm-poi-box ion-card ion-card-header ion-card-title {
  text-align: left;
  color: var(--wm-color-dark);
  margin: 10px;
  padding: 5px 0 0;
  font-size: var(--wm-font-sm);
  font-weight: var(--wm-font-weight-normal);
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  /* white-space: nowrap; */
  overflow: hidden;
  text-overflow: ellipsis;
}
wm-poi-box ion-card ion-card-header ion-card-title::first-letter {
  text-transform: uppercase;
}
wm-poi-box ion-card ion-card-header .wm-card-big-subtitle-skeleton {
  margin: 15px 0 0;
  height: var(--wm-font-xsm);
  width: 50%;
}
wm-poi-box ion-card ion-card-header .wm-card-big-title-skeleton {
  margin: 5px 0 0;
  height: var(--wm-font-md);
  width: 70%;
}
wm-poi-box ion-card .wm-card-big-distance {
  text-align: left;
  color: var(--wm-color-darkgrey);
  height: var(--wm-font-sm);
  margin: 10px;
}
wm-poi-box ion-card wm-updated-at {
  margin-top: 10px;
}
wm-poi-box ion-card .top-right-content {
  position: absolute;
  right: 5px;
  top: 5px;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/wm-core/projects/wm-core/src/box/poi-box/poi-box.component.scss","webpack://./src/app/shared/wm-core/projects/wm-core/src/theme/mixins.scss"],"names":[],"mappings":"AACA;EACE,eAAA;EACA,YAAA;AAAF;AACE;EACE,YAAA;AACJ;AACE;EACE,gBAAA;EACA,UAAA;EACA,iBAAA;EACA,mBAAA;EACA,aAAA;EACA,YAAA;ECZF,2CAAA;ADcF;AAAI;EACE,mDAAA;AAEN;AAAI;EACE,cAAA;EACA,0CAAA;EACA,2BAAA;EACA,4BAAA;EACA,sBAAA;AAEN;AAAI;EACE,+BAAA;EACA,yBAAA;EACA,4BAAA;AAEN;AADM;EACE,uCAAA;AAGR;AAAI;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;AAEN;AADM;EACE,SAAA;EACA,QAAA;EACA,mBAAA;EACA,0BAAA;EACA,uBAAA;EACA,yBAAA;EACA,WAAA;EAEA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,uBAAA;EACA,sBAAA;EACA,mBAAA;AAER;AADQ;EACE,YAAA;AAGV;AADQ;EACE,cAAA;EACA,gBAAA;EAEA,oBAAA;EACA,mBAAA;EACA,iBAAA;EACA,2BAAA;EACA,qBAAA;EACA,mBAAA;AAEV;AAEI;EACE,mBAAA;AAAN;AACM;EACE,kBAAA;EACA,MAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;AACR;AAGI;EACE,eAAA;EACA,gBAAA;AADN;AAEM;EACE,gBAAA;EACA,8BAAA;EACA,yBAAA;EACA,SAAA;EACA,iBAAA;EACA,6BAAA;EACA,wCAAA;AAAR;AAEM;EACE,gBAAA;EACA,2BAAA;EACA,YAAA;EACA,gBAAA;EACA,4BAAA;EACA,yCAAA;EAIA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,yBAAA;EACA,gBAAA;EACA,uBAAA;AAHR;AALQ;EACE,yBAAA;AAOV;AAGM;EACE,gBAAA;EACA,0BAAA;EACA,UAAA;AADR;AAGM;EACE,eAAA;EACA,yBAAA;EACA,UAAA;AADR;AAKI;EACE,gBAAA;EACA,+BAAA;EACA,yBAAA;EACA,YAAA;AAHN;AAKI;EACE,gBAAA;AAHN;AAKI;EACE,kBAAA;EACA,UAAA;EACA,QAAA;AAHN","sourcesContent":["@import '../../theme/mixins.scss';\nwm-poi-box {\n  cursor: pointer;\n  margin: 10px;\n  wm-img {\n    height: 30px;\n  }\n  ion-card {\n    overflow: hidden;\n    width: 90%;\n    max-height: 250px;\n    border-radius: 15px;\n    padding: 10px;\n    margin: auto;\n    @include box-shadow-light;\n    .wm-box-name {\n      font-family: var(--wm-font-family-content, inherit);\n    }\n    wm-img {\n      display: block;\n      background-color: var(--wm-color-skeleton);\n      background-position: center;\n      background-repeat: no-repeat;\n      background-size: cover;\n    }\n    ion-label {\n      color: var(--wm-color-darkgrey);\n      height: var(--wm-font-sm);\n      font-size: var(--wm-font-sm);\n      span {\n        font-weight: var(--wm-font-weight-bold);\n      }\n    }\n    .wm-box-taxonomies {\n      position: absolute;\n      top: 10px;\n      padding: 1%;\n      display: flex;\n      flex-direction: row;\n      flex-wrap: wrap;\n      .wm-box-taxonomy {\n        left: 0px;\n        top: 0px;\n        border-radius: 25px;\n        padding: 6px 10px 6px 10px;\n        background-color: white;\n        border: 1px solid #888888;\n        margin: 3px;\n\n        display: flex;\n        flex-direction: row;\n        flex-wrap: wrap;\n        justify-content: center;\n        align-content: stretch;\n        align-items: center;\n        i {\n          color: unset;\n        }\n        > * {\n          flex: 0 1 auto;\n          align-self: auto;\n\n          display: inline-flex;\n          flex-direction: row;\n          flex-wrap: nowrap;\n          justify-content: flex-start;\n          align-content: center;\n          align-items: center;\n        }\n      }\n    }\n    .wm-box-header-no-photo {\n      height: fit-content;\n      .wm-box-taxonomies {\n        position: relative;\n        top: 0;\n        padding: 1%;\n        display: flex;\n        flex-direction: row;\n        flex-wrap: wrap;\n      }\n    }\n\n    ion-card-header {\n      padding: 0 15px;\n      text-align: left;\n      ion-card-subtitle {\n        text-align: left;\n        color: var(--wm-color-primary);\n        text-transform: uppercase;\n        margin: 0;\n        padding: 15px 0 0;\n        font-size: var(--wm-font-xsm);\n        font-weight: var(--wm-font-weight-light);\n      }\n      ion-card-title {\n        text-align: left;\n        color: var(--wm-color-dark);\n        margin: 10px;\n        padding: 5px 0 0;\n        font-size: var(--wm-font-sm);\n        font-weight: var(--wm-font-weight-normal);\n        &::first-letter {\n          text-transform: uppercase;\n        }\n        display: -webkit-box;\n        -webkit-line-clamp: 2;\n        -webkit-box-orient: vertical;\n        /* white-space: nowrap; */\n        overflow: hidden;\n        text-overflow: ellipsis;\n      }\n\n      .wm-card-big-subtitle-skeleton {\n        margin: 15px 0 0;\n        height: var(--wm-font-xsm);\n        width: 50%;\n      }\n      .wm-card-big-title-skeleton {\n        margin: 5px 0 0;\n        height: var(--wm-font-md);\n        width: 70%;\n      }\n    }\n\n    .wm-card-big-distance {\n      text-align: left;\n      color: var(--wm-color-darkgrey);\n      height: var(--wm-font-sm);\n      margin: 10px;\n    }\n    wm-updated-at {\n      margin-top: 10px;\n    }\n    .top-right-content {\n      position: absolute;\n      right: 5px;\n      top: 5px;\n    }\n  }\n}\n","@mixin box-shadow-light {\n  box-shadow: 0 2px 20px 0 rgba(0, 0, 0, 0.1);\n}\n\n@mixin box-shadow-dark {\n  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.4);\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
